import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from "./authSlice";
import paymentDetailsReducer from "./paymentDetails";

// Persist configuration for auth
const authPersistConfig = {
  key: "auth",
  storage,
  whitelist: ["user", "token", "isAuthenticated"], // Only auth state keys for auth slice
};

// Persist configuration for paymentDetails
const paymentDetailsPersistConfig = {
  key: "paymentDetails",
  storage,
  whitelist: ["paymentData"], // Persist only paymentData from paymentDetails slice
};

// Create persisted reducers
const persistedAuthReducer = persistReducer(authPersistConfig, authReducer);
const persistedPaymentDetailsReducer = persistReducer(
  paymentDetailsPersistConfig,
  paymentDetailsReducer
);

// Configure store
export const store = configureStore({
  reducer: {
    auth: persistedAuthReducer,
    paymentDetails: persistedPaymentDetailsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
});

// Create persistor
export const persistor = persistStore(store);

// Types
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
